import { Expose } from 'class-transformer';
import { ProjectModel } from '../project/project.model';

export class InvoiceConfiguration {
  public project: ProjectModel | null = null;
  public expenditureType = '';
  public tmHours = '';
  public tmGrouping = '';
  public invoicedSince = new Date();
}

export class InvoicePositionModel {
  public id = -1;
  public description = '';
  public price = -1;
  @Expose({ name: 'timeblock_ids' })
  timeBlockIds: number[] = [];
}
